import TransferBoxDetailDialog from "./transferBoxDetailDialog.container";

export default TransferBoxDetailDialog;
